import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-8 bg-white flex col-gap-8 px-10" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "px-10 pt-10"
}
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListTitle = _resolveComponent("ListTitle")!
  const _component_ListNewItem = _resolveComponent("ListNewItem")!
  const _component_EmptyPage = _resolveComponent("EmptyPage")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterBtn, (btn) => {
        return (_openBlock(), _createElementBlock("div", {
          key: btn.value,
          class: _normalizeClass([[_ctx.active === btn.value ? 'bg-theme2 text-theme' : 'bg-gray text-666'], "text-12 h-24 flex items-center px-10 rounded-2"]),
          onClick: ($event: any) => (_ctx.toggleActive(btn.value))
        }, _toDisplayString(btn.text), 11, _hoisted_2))
      }), 128))
    ]),
    _createVNode(_component_van_list, {
      loading: _ctx.state.loading,
      "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.loading) = $event)),
      finished: _ctx.state.finished,
      "finished-text": "没有更多了",
      onLoad: _ctx.goOnLoad
    }, {
      default: _withCtx(() => [
        (_ctx.state.list.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.list, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "list-item",
                  onClick: ($event: any) => (_ctx.toDetail(item.id))
                }, [
                  _createVNode(_component_ListTitle, {
                    name: `${item.user_name || ''}${item.user_name ? '的' : ''}${item.name}`
                  }, null, 8, ["name"]),
                  _createVNode(_component_ListNewItem, {
                    label: "审批编号",
                    value: item.code
                  }, null, 8, ["value"]),
                  _createVNode(_component_ListNewItem, {
                    label: "审批内容",
                    value: item.desc
                  }, null, 8, ["value"]),
                  _createVNode(_component_ListNewItem, {
                    label: "发起时间",
                    value: item.create_date
                  }, null, 8, ["value"]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["list-item-status", _ctx.statusClass(item.state)])
                  }, _toDisplayString(item.state_name), 3)
                ], 8, _hoisted_4))
              }), 128))
            ]))
          : (_openBlock(), _createBlock(_component_EmptyPage, {
              key: 1,
              style: {"margin-top":"100px !important"},
              isHide: true
            }))
      ]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"])
  ]))
}